<div class="my-dialog-container">
  <div class="my-header">
    <div class="my-header-row">
      <div>
        <h2 appCmsTranslation="version.update-dialog.title">
          A new version of the application is available.
        </h2>
      </div>
      <div></div>
    </div>
  </div>
  <div mat-dialog-content>
    <p appCmsTranslation="version.update-dialog.text">
      Please accept the update.
    </p>
  </div>
  <div mat-dialog-actions>
    <section class="my-button-section">
      <button
        type="button"
        color="accent"
        mat-stroked-button
        (click)="onPostpone()"
      >
        <span>
          Redemander dans 5 min
        </span>
      </button>
      <button
        type="button"
        color="accent"
        mat-raised-button
        (click)="onSubmit()"
      >
        <span>
          Mettre à jour maintenant
        </span>
      </button>
    </section>
  </div>
</div>
